import { html } from 'htm/preact';
import { useEffect, useRef } from 'preact/hooks';

import Button from './Button';

const ConfirmDialog = ({ isOpen, title, description, onConfirm, onCancel }) => {
  const dialogRef = useRef(null);

  useEffect(() => {
    if (!dialogRef.current) return;

    if (isOpen) {
      dialogRef.current.classList.remove('animate-dialog-open');

      if (typeof dialogRef.current.showModal === 'function') {
        dialogRef.current.showModal();
      } else {
        dialogRef.current.style.display = 'block';
      }

      // Animate the dialog after it's opened
      requestAnimationFrame(() => {
        dialogRef.current.classList.add('animate-dialog-open');
      });
    } else {
      dialogRef.current.close();
    }
  }, [isOpen, dialogRef]);

  return html`
    <dialog
      class="cart-dialog hidden open:flex justify-center rounded-4xl flex-col fixed w-auto max-w-[95%] md:max-w-2xl max-h-none bg-stone m-auto p-8 lg:p-12 pb-14 transition duration-300 translate-y-1/2 opacity-0"
      ref=${dialogRef}
    >
      <div class="flex flex-col items-center mb-3">
        <h3 class="flex h4 mb-2 normal-case text-center">${title}</h3>
        <p class="text-sm text-center">${description}</p>
      </div>
      <div class="flex flex-col lg:flex-row justify-center gap-4 mt-4">
        <${Button} text="Cancel" onClick=${onCancel} secondary />
        <${Button} text="Confirm" onClick=${onConfirm} />
      </div>
    </dialog>
  `;
};

export default ConfirmDialog;
